import DateTime from "components/presentation/DateTime"
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import Status from "components/presentation/Status";
import Label from "components/general/Label"
import { getDateTimeFormat } from "helpers/utils";
import SportCode from "components/common/SportCode";

export function Footer({ data }) {

    const formatDate = getDateTimeFormat('DayMonthShort')
    const formatDateTime = getDateTimeFormat('DayMonthShortHourMinute');
    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} />, <SportCode entity='@CompetitorPlace' code="TBD" abbr={true} /></>
    const dateComponent = data?.bi_time ? dateTimeFormated : date
    const numberGame = data?.bracketItemCode

    return (
        <>
            {isLiveStatus(data?.result?.status?.code) && <div className='score-status justify-content-end'>
                <Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={data?.result?.status?.code} />
            </div>}
            {isLessLiveStatus(data?.result?.status?.code) && (<div className='d-flex'><div className='text-start'>{dateComponent}</div></div>)}
            {isLessLiveStatus(data?.result?.status?.code) && (<div className='d-flex'><div className='text-end'><Label data='HeaderBout' /> {numberGame}</div></div>)}
        </>
    )
}

export function CompetitorBlockNoData(competitor) {
    return (
        <div className=' d-flex flex-row justify-content-start'>
            <div className=''>
                {competitor
                    ? competitor.cp_code
                    : <></>
                }
            </div>
        </div>
    )
}